import React from 'react';
import ClearIconML from '@/components/ClearIconML/index';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useIntl } from 'umi';
import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = (props) => {
  //过于国际化的方法
  const intl = useIntl();
  const { formatMessage } = intl;
  const { setSearchData } = props;
  const appList = [
    { name: '电商微信小程序', value: 'wechat' },
    { name: '私域小程序', value: 'PRIVATEPROGRAM' },
  ];
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      storeNo: 'wechat',
    },
  });
  // 每个输入框清除数据

  const handleClearStore = () => {
    setValue('storeNo', '');
    // reset('channel', '');
  };
  const watchStore = watch('storeNo');
  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    setSearchData(submitData.storeNo);
  };
  //点击重置
  const handleRestClick = () => {
    setSearchData('wechat');
    setValue('storeNo', 'wechat');
  };

  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line">
              <FormControl variant="standard" className="gender">
                <InputLabel>小程序</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('storeNo', '')}
                              edge="end"
                            >
                              {/* {getValues().memberCode ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )} */}
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {appList && appList.length > 0 ? (
                        appList.map((item) => (
                          <MenuItem
                            key={item.value}
                            value={item.value}
                            name={item.value}
                          >
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>暂无数据</MenuItem>
                      )}
                    </Select>
                  }
                  // label="会员等级"
                  name="storeNo"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                {watchStore ? (
                  <ClearIconML
                    handleClick={handleClearStore}
                    clearValue={watchStore}
                  ></ClearIconML>
                ) : (
                  ''
                )}
              </FormControl>
              <div></div>
              <div></div>
              <div></div>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.member.n01.btn10' })}
            </Button>

            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.member.n01.btn11' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};

export default SearchGroup;
